//move our jQuery
//window.jQuery341 = jQuery.noConflict();

//restore WP jQuery (saved in ./save-wp-jquery.js)
//window.jQuery = window.jQueryWP;
//window.$ = window.jQueryWP;

import { cookie, cookieExists } from './cookie.js';
import { initCommunity } from './community.js';
import { initCommunityNewsPagination } from './community-news-pagination.js';
import { initBlogPagination } from './blog-pagination.js';
import { initOffsiteLinks } from './offsite-links.js';
import { initSharing } from './sharing.js';
import {
    openDesktopNav,
    closeDesktopNav,
    closeAllDesktopMainNavs,
    closeAllDesktopUtilityNavs,
    openLoginDropdown,
    closeLoginDropdown,
    closeAllDesktopDropdowns,
    openDesktopLocationSelect,
    closeDesktopLocationSelect
} from './menus.js';
import { keyboardFocusClass, keyboardFocus, initKeyboardNavigation } from './keyboard-navigation.js';

//shorthand for jQuery(document).ready(function ($) { //stuff });
jQuery(function ($) {
    
    initCommunity();
    initCommunityNewsPagination();
    initBlogPagination();
    initOffsiteLinks();
    initSharing();
    initKeyboardNavigation();

    //apply focus styles on keyboard focus, but not on mouse focus
    $("body").on("keyup", "*", function (e) {
        if (e.which !== 9) { //tab
            return;
        }

        if ($(e.target).is("a, :input, .question-row, .checkbox-wrapper, .search-link button, .search-submit")) {
            keyboardFocusClass($(e.target));
        }

        //special handling for slick sliders
        // var focused = $(this).closest('.slide');
        // if (($(this).is(":focus") || $(this).is(e.target)) && focused.length > 0) {
        //     focused.addClass("keyboard-focus").on("blur", function () {
        //         $(this).off("blur").removeClass("keyboard-focus");
        //     });
        // }
    });
});

jQuery(document).ready(function($){
    // browser sniffing
    var is_chrome = navigator.userAgent.indexOf('Chrome') > -1;
    var is_explorer = navigator.userAgent.indexOf('MSIE') > -1;
    var is_explorer_11 = navigator.userAgent.indexOf('rv:11.0') > -1;
    var is_firefox = navigator.userAgent.indexOf('Firefox') > -1;
    var is_safari = navigator.userAgent.indexOf("Safari") > -1;
    var is_edge = navigator.userAgent.indexOf("Edge") > -1;
    var is_opera = navigator.userAgent.toLowerCase().indexOf("op") > -1;
    if ((is_chrome)&&(is_safari)) { is_safari = false; }
    if ((is_chrome)&&(is_opera)) { is_chrome = false; }
    if ((is_edge)) { is_chrome = false; is_safari = false; }

    if((!(is_explorer))&&(!(is_explorer_11))&&(!(is_edge))) {
        $('body').addClass('browser-not-microsoft');
    }
    if(is_safari) {
        $('body').addClass('browser-safari');
    }
    if(is_edge) {
        $('body').addClass('browser-edge');
    }
    if(is_explorer) {
        $('body').addClass('browser-ie');
    }
    if(is_explorer_11) {
        $('body').addClass('browser-ie11');
    }

    // window size variables (bootstrap 4)
    var xsMax = Modernizr.mq('(max-width:575px)'),
        smMax = Modernizr.mq('(max-width:767px)'),
        mdMax = Modernizr.mq('(max-width:991px)'),
        lgMax = Modernizr.mq('(max-width:1199px)'),
        smMin = Modernizr.mq('(min-width:576px)'),
        mdMin = Modernizr.mq('(min-width:768px)'),
        lgMin = Modernizr.mq('(min-width:992px)'),
        xlMin = Modernizr.mq('(min-width:1200px)'),
        notMobile = !(Modernizr.touch && smMax);

    $(window).on('resize', function(){
        xsMax = Modernizr.mq('(max-width:575px)');
        smMax = Modernizr.mq('(max-width:767px)');
        mdMax = Modernizr.mq('(max-width:991px)');
        lgMax = Modernizr.mq('(max-width:1199px)');
        smMin = Modernizr.mq('(min-width:576px)');
        mdMin = Modernizr.mq('(min-width:768px)');
        lgMin = Modernizr.mq('(min-width:992px)');
        xlMin = Modernizr.mq('(min-width:1200px)');
    });

    //keep track of mobile menu panes and links (for managing visibility and tabability)
    var linksStack = [],
        panesStack = [];

    // add not-mobile vs. mobile class to body
    function mobileCheck() {
        if(notMobile) {
            $('body').addClass('not-mobile');
            return false;
        } else {
            $('body').addClass('mobile');
            return true;
        }
    }

    mobileCheck();

    $(window).on('resize', function(){
        mobileCheck();
        bannerPadding()

        closeAllDesktopDropdowns();

        if ($(window).width() > 991) {
            $('.mobile-nav-area .nav-bottom').removeClass('open').attr('aria-hidden', 'true').attr('tabindex', '-1');
            $('.mobile-nav-area .mobile-menu-toggle, .mobile-nav-area .top-subnav,.mobile-nav-area .mainnav-trigger,.mobile-nav-area .utility-trigger,.mobile-nav-area .utility-sub,.mobile-nav-area .meganav-submenu-container').removeClass('open');
        }

        var slug = location.pathname.split("/")[1];
            ocb = cookie('ocb') || {};

        if (slug) {
            $('.mainnav-trigger[data-submenu="sub-top-' + slug + '"]').addClass('active');
            $('#sub-top-' + slug).addClass('open').attr('aria-hidden', 'false').find('.meganav-trigger > a, .meganav-trigger > :input').attr('tabindex', '0');
            $('[data-js="home-link"]').each(function () {
                var link = $(this),
                    urls = link.data('urls');

                if (urls[slug]) {
                    link.attr('href', urls[slug]);
                }
            });
        }

        //fallback to cookie
        if (!$('.mainnav-trigger[data-submenu^="sub"]').hasClass('active')) {

            $('.mainnav-trigger[data-submenu="sub-top-' + ocb.section + '"]').addClass('active');
            $('#sub-top-' + ocb.section).addClass('open').attr('aria-hidden', 'false').find('.meganav-trigger > a, .meganav-trigger > :input').attr('tabindex', '0');

            $('[data-js="home-link"]').each(function () {
                var link = $(this),
                    urls = link.data('urls');

                if (urls[ocb.section]) {
                    link.attr('href', urls[ocb.section]);
                }
            });
        }

        //fallback to first item
        if (!$('.mainnav-trigger[data-submenu^="sub"]').hasClass('active')) {
            $('.mainnav-trigger.first').addClass('active');
            $('.top-subnav.first').addClass('open').attr('aria-hidden', 'false').find('.meganav-trigger a, .meganav-trigger :input').attr('tabindex', '0');

            slug = $('.mainnav-trigger.first').attr('href').split("/")[1];

            $('[data-js="home-link"]').each(function () {
                var link = $(this),
                    urls = link.data('urls');

                if (urls[slug]) {
                    link.attr('href', urls[slug]);
                }
            });
        }

    });


    //set all megamenus to hidden
    closeAllDesktopDropdowns();
    //hide mobile nav
    $('.mobile-menu-toggle').removeClass('open');
    $('.mobile-nav-area .nav-bottom').removeClass('open').attr('aria-hidden', 'true').find('a, :input').attr('tabindex', '-1');


    //mobile nav
    $('.mobile-menu-toggle').on('click keydown',function(e){
        var scrollTop = $(window).scrollTop();

        if (e.type == 'keydown') {
            if (!(e.which == 13 || e.which == 32)) {
                return;
            }
        }

        if($(this).hasClass('open')){
            $(this).removeClass('open').removeAttr('aria-expanded');
            $('.mobile-nav-area .nav-bottom').removeClass('open').attr('aria-hidden', 'true').find('a, :input').attr('tabindex', '-1');
            $('.mobile-nav-area .top-subnav, .utility-sub-inner, .mobilenav-submenu-inner-wrapper').removeClass('submenu-open').attr('aria-hidden', 'true').find('a, :input').attr('tabindex', '-1');
            $('.mainnav-trigger, .utility-trigger, .utility-sub, .meganav-submenu-container').removeClass('open');
        }else{
            $(this).addClass('open').attr('aria-expanded', 'true');
            $('.mobile-nav-area .nav-bottom').addClass('open').attr('aria-hidden', 'false').find('a, :input').not('.top-subnav a, .top-subnav :input, .mobilenav-submenu-inner-wrapper a, .mobilenav-submenu-inner-wrapper :input, .utility-sub-inner a, utility-sub-inner :input, .location-choice a').attr('tabindex', '0');
            keyboardFocus(keyboardFocusClass($('.mobile-nav-area').find('.mainnav-trigger, .standard-link').first()));
        }

        return false;
    });


    //nav active state
    $(function() {

        var slug = location.pathname.split("/")[1];
            ocb = cookie('ocb') || {};

        if (!Object.keys($('[data-js="home-link"]').data('urls')).includes(slug)) {
            slug = false;
        }

        if (slug) {

            ocb.section = slug;

            $('.mainnav-trigger[data-submenu="sub-top-' + slug + '"]').addClass('active');
            $('#sub-top-' + slug).addClass('open').attr('aria-hidden', 'false').find('.meganav-trigger > a, .meganav-trigger > :input').attr('tabindex', '0');
            $('[data-js="home-link"]').each(function () {
                var link = $(this),
                    urls = link.data('urls');

                if (urls[slug]) {
                    link.attr('href', urls[slug]);
                }
            });

            $('[data-js="login-form-select"] option').prop('selected', false).filter('[data-js="' + slug + '"]').prop('selected', true).closest('[data-js="login-form-select"]').trigger('change');
        }

        cookie('ocb', ocb, 60*60*24*365);

        //fallback to cookie
        if (!$('.mainnav-trigger[data-submenu^="sub"]').hasClass('active')) {

            $('.mainnav-trigger[data-submenu="sub-top-' + ocb.section + '"]').addClass('active');
            $('#sub-top-' + ocb.section).addClass('open').attr('aria-hidden', 'false').find('.meganav-trigger > a, .meganav-trigger > :input').attr('tabindex', '0');

            $('[data-js="home-link"]').each(function () {
                var link = $(this),
                    urls = link.data('urls');

                if (urls[ocb.section]) {
                    link.attr('href', urls[ocb.section]);
                }
            });

            $('[data-js="login-form-select"] option').prop('selected', false).filter('[data-js="' + ocb.section + '"]').prop('selected', true).closest('[data-js="login-form-select"]').trigger('change');
        }

        //fallback to first item
        if (!$('.mainnav-trigger[data-submenu^="sub"]').hasClass('active')) {
            $('.mainnav-trigger.first').addClass('active');
            $('.top-subnav.first').addClass('open').attr('aria-hidden', 'false').find('.meganav-trigger a, .meganav-trigger :input').attr('tabindex', '0');

            slug = $('.mainnav-trigger.first').attr('href').split("/")[1];

            $('[data-js="home-link"]').each(function () {
                var link = $(this),
                    urls = link.data('urls');

                if (urls[slug]) {
                    link.attr('href', urls[slug]);
                }
            });

            $('[data-js="login-form-select"] option').prop('selected', false).filter('[data-js="' + slug + '"]').prop('selected', true).closest('[data-js="login-form-select"]').trigger('change');
        }
    });



    // hide open dropdowns on body (not trigger or meganav) click
    $('body').on('click keydown keyup', function(event) {

        //close login dialog when tabbing away
        if (event.type == 'keyup') {
            if ($(event.target).closest('.login-dropdown-container').length == 0 && $('.login-dropdown').is('.open')) {
                closeLoginDropdown($('.login-dropdown'));
            }

            //also the my location select
            if ($(event.target).closest('.my-location').length == 0) {
				closeDesktopLocationSelect($('[data-js="current-location"]'));
			}

            //also close desktop nav search dialog
            if ($(event.target).closest('.search-link').length == 0 && $(event.target).closest('.search-form-container').length == 0) {
                if($('.desktop-search-dialog').hasClass('open')){
                    $('.search-link button').removeClass('open');
                    $('.desktop-search-dialog').removeClass('open');
                    $('.desktop-search-dialog .search-field, .desktop-search-dialog .search-submit').attr('tabindex', -1);
                    $('.search-link button').focus();
                }
            }

            return;
        }
        //close login dialog when pressing escape
        if (event.type == 'keydown') {
            if (event.which == 27) {
                if ($(event.target).closest('.login-dropdown-container').length > 0 && $('.login-dropdown').is('.open')) {
                    closeLoginDropdown($('.login-dropdown'));
                    $('.login-dropdown:visible').first().get(0).focus();
                }

                //also the my location select
                if ($(event.target).closest('.my-location').length == 0) {
                    closeDesktopLocationSelect($('[data-js="current-location"]'));
                }

                //also close desktop nav search dialog
                if($('.desktop-search-dialog').hasClass('open')){
                    $('.search-link button').removeClass('open');
                    $('.desktop-search-dialog').removeClass('open');
                    $('.desktop-search-dialog .search-field, .desktop-search-dialog .search-submit').attr('tabindex', -1);
                    $('.search-link button').focus();
                }
            }

            return;
        }

        if (event.type == 'keydown') {
            if (!(event.which == 13 || event.which == 32)) {
                return;
            }
        }

        if ($(event.target).closest('.trigger-container, .top-utility, .login-box').length == 0) {

            closeAllDesktopDropdowns();

            $('.search-link button').removeClass('open');
            $('.desktop-search-dialog').removeClass('open');
            $('.desktop-search-dialog .search-field, .desktop-search-dialog .search-submit').attr('tabindex', -1);

            $('.slick-slide a').removeClass('keyboard-focus');
        }
    });

    $('.my-location').on('click keydown',function(e){
        if (e.type == 'keydown') {
            if (!(e.which == 13 || e.which == 32)) {
                return;
            }
        }

        closeAllDesktopMainNavs();
        closeAllDesktopUtilityNavs();
        closeLoginDropdown($('.login-dropdown'));
        $('[data-js="location-choice"]').attr('tabindex','-1');
        $('.search-link button, .desktop-search-dialog').removeClass('open');
        $('.desktop-search-dialog .search-field, .desktop-search-dialog .search-submit').attr('tabindex', -1);
    });


    $('.meganav-submenu-inner-wrapper, .meganav-submenu-container, .utility-trigger').click(function(e){
        e.stopPropagation();
    });

    $('.mainnav-back').on('click keydown', function(e){
        //let other key presses proceed as normal (namely 'tab' keyboard navigation)
        if (e.type == 'keydown' && e.which !== 13) {
            return;
        }

        $('.top-subnav, .utility-sub-inner').removeClass('submenu-open').attr('aria-hidden', 'true').find('a, :input').attr('tabindex', '-1');
        $('.mainnav-trigger, .utility-trigger, .utility-sub').removeClass('open');
        $('.utility-sub').removeClass('open');
        $('[data-js="location-choice"]').attr('tabindex','-1');

        //reset tabindexes/visibility on previous menu
        var paneFrame,
            linkFrame;

        if (panesStack.length > 0) {
            paneFrame = panesStack.pop();
            paneFrame.attr('aria-hidden', 'false');
        }
        if (linksStack.length > 0) {
            linkFrame = linksStack.pop();

            linkFrame.filter('[aria-expanded]').removeAttr('aria-expanded');
            keyboardFocus(keyboardFocusClass(linkFrame.attr('tabindex', '0').not('.back-nav-item a').first()));

            if (linksStack.length > 0) {
                linkFrame = linksStack.pop();

                linkFrame.filter('[data-submenu="' + paneFrame.attr('id') + '"]').attr('aria-expanded', 'true');

                linksStack.push(linkFrame);
            }
        }
    })

    $('.subnav-back').on('click keydown', function(e){
        //let other key presses proceed as normal (namely 'tab' keyboard navigation)
        if (e.type == 'keydown' && e.which !== 13) {
            return;
        }
        $('.meganav-submenu-inner-wrapper').removeClass('open').attr('aria-hidden', 'true').find('a, :input').attr('tabindex', '-1');
        $('.mobilenav-submenu-inner-wrapper').removeClass('submenu-open').attr('aria-hidden', 'true').find('a, :input').attr('tabindex', '-1');

        //reset tabindexes/visibility on previous menu
        var paneFrame,
            linkFrame;

        if (panesStack.length > 0) {
            paneFrame = panesStack.pop();
            paneFrame.attr('aria-hidden', 'false');
        }
        if (linksStack.length > 0) {
            linkFrame = linksStack.pop();

            linkFrame.filter('[aria-expanded]').removeAttr('aria-expanded');
            keyboardFocus(keyboardFocusClass(linkFrame.attr('tabindex', '0').not('.back-nav-item a').first()));

            if (linksStack.length > 0) {
                linkFrame = linksStack.pop();

                linkFrame.filter('[data-submenu="' + paneFrame.attr('id') + '"]').attr('aria-expanded', 'true');

                linksStack.push(linkFrame);
            }
        }
    })


    $('.login-dropdown').on('click keydown',function(e){

        if (e.type == 'keydown') {
            if (!(e.which == 13 || e.which == 32)) {
                return;
            }
        }

        closeAllDesktopMainNavs();
        closeAllDesktopUtilityNavs();
        closeDesktopLocationSelect($('[data-js="current-location"]'));
        $('.search-link button, .desktop-search-dialog').removeClass('open');
        $('.desktop-search-dialog .search-field, .desktop-search-dialog .search-submit').attr('tabindex', -1);

        if($(this).hasClass('open')){
            closeLoginDropdown($(this));
        }else{
            openLoginDropdown($(this));

            keyboardFocus($('.login-dropdown-container:visible form :input').first());
            if (e.type == 'keydown') {
                keyboardFocusClass($('.login-dropdown-container:visible form :input').first());
            }
        }

        return false;

    })


    //'keydown' so that they can be opened by pressing 'enter' key
    $('.meganav-trigger, .utility-trigger, .mobile-main-nav .mainnav-trigger').on('click keydown', function(e){

        //let other key presses proceed as normal (namely 'tab' keyboard navigation)
        if (e.type == 'keydown' && e.which !== 13) {
            return;
        }

        e.preventDefault();
        var target = $(this).data('submenu');

        closeAllDesktopUtilityNavs();
        closeLoginDropdown($('.login-dropdown'));
        closeDesktopLocationSelect($('[data-js="current-location"]'));

        $('.search-link button, .desktop-search-dialog').removeClass('open');
        $('.desktop-search-dialog .search-field, .desktop-search-dialog .search-submit').attr('tabindex', -1);

        if($("#"+target).hasClass('submenu-open')){
            $(this).removeClass('open');

            closeAllDesktopMainNavs();
            closeAllDesktopUtilityNavs();

            $('.mobile-nav-area .nav-bottom').removeClass('open').attr('aria-hidden', 'true').find('a, :input').attr('tabindex', '-1');
        }else{

            closeAllDesktopMainNavs();
            closeAllDesktopUtilityNavs();

            $('.meganav-submenu-inner-wrapper').removeClass('submenu-open').attr('aria-hidden', 'true').find('a, :input').attr('tabindex', '-1');

            if($(this).hasClass('meganav-trigger')){

                if ($(this).closest('#mobileNav').length > 0) {

                    //save current pane onto the stack
                    panesStack.push($('#mobileNav [aria-hidden="false"]'));
                    //save current links onto the stack
                    linksStack.push($('#mobileNav [tabindex="0"]'));
                    //hide all other panes
                    $('#mobileNav').find('[aria-hidden]').attr('aria-hidden', 'true');
                    $('#mobileNav').find('[aria-expanded]').removeAttr('aria-expanded');
                    //disable all other links
                    $('#mobileNav').find('[tabindex]').attr('tabindex', '-1');

                    $(this).closest('.trigger-container').next('.meganav-submenu-container').addClass('open');
                    $("#"+target).addClass('submenu-open').attr('aria-hidden', 'false').find('a, :input').attr('tabindex', '0');
                    $(this).addClass('open').attr('aria-expanded', 'true');
                } else {
                    openDesktopNav($(this));
                }
            }

            if($(this).hasClass('utility-trigger')){

                openDesktopNav($(this));
            }

            if($(this).hasClass('mainnav-trigger')){

                //save current pane onto the stack
                panesStack.push($('#mobileNav [aria-hidden="false"]'));
                //save current links onto the stack
                linksStack.push($('#mobileNav [tabindex="0"]'));
                //hide all other panes
                $('#mobileNav').find('[aria-hidden]').attr('aria-hidden', 'true');
                $('#mobileNav').find('[aria-expanded]').removeAttr('aria-expanded');
                //disable all other links
                $('#mobileNav').find('[tabindex]').attr('tabindex', '-1');

                $('.mobile-nav-area .top-subnav').addClass('open');
                $("#"+target).addClass('submenu-open').attr('aria-hidden', 'false').find('a, :input').not('.mobilenav-submenu-inner-wrapper a').attr('tabindex', '0');
                $(this).addClass('open').attr('aria-expanded', 'true');
            }

        }
    });

    //nav search tab interaction
    $('.desktop-search-dialog .search-field, .desktop-search-dialog .search-submit').attr('tabindex', -1);
    $('.search-link button').on('click',function(event){
            if($(this).hasClass('open')){
                $(this).removeClass('open').removeAttr('aria-expanded');
                $('.desktop-search-dialog').removeClass('open');
                $('.desktop-search-dialog .search-field, .desktop-search-dialog .search-submit').attr('tabindex', -1);
                $('.search-link button').focus();
            }else{
                //close everything else
                closeAllDesktopDropdowns();

                //open search dialog
                $(this).addClass('open').attr('aria-expanded', 'true');
                $('.desktop-search-dialog').addClass('open');
                $('.desktop-search-dialog .search-field, .desktop-search-dialog .search-submit').attr('tabindex', 0);
                $('.desktop-search-dialog .search-field').focus();
            }
    });


    function bannerPadding(){
        if($('.main-nav').hasClass('has-banner')) {
            var bodyPad = $('.main-nav').outerHeight();


            if (window.innerWidth < 991) {
                $('body').css('padding-top',bodyPad + 'px');
                $('.mobile-top-utility .utility-nav-item .utility-sub, .mobile-nav-area .nav-bottom, .mobile-main-nav .top-subnav, .mobilenav-submenu-inner-wrapper').css('top',bodyPad + 'px');
            }else{
                $('body').css('padding-top','0px');
                $('.mobile-top-utility .utility-nav-item .utility-sub, .mobile-nav-area .nav-bottom, .mobile-main-nav .top-subnav, .mobilenav-submenu-inner-wrapper').css('top','100px');
            }
        }
    }

    bannerPadding();

    function bannerScrollPadding(){

        if($('.main-nav').hasClass('has-banner')) {
            var bodyPad = $('.main-nav').outerHeight();

            if (window.innerWidth < 991) {
                $('body').animate({paddingTop: bodyPad + 'px'},{duration: 2, easing: "linear" });
                $('.mobile-nav-area .nav-bottom, .mobile-main-nav .top-subnav, .mobilenav-submenu-inner-wrapper').animate({top:bodyPad + 'px'},{duration: 2, easing: "linear" });
            }
        }
    }

    //sticky nav
	var scrollDistance;
	if($('.main-nav').hasClass('has-banner')) {
		var bannerHeight = $('.banner-wrapper').outerHeight();
		scrollDistance = 100 + bannerHeight;
        var bodyPad = $('.main-nav').outerHeight();

	} else {
		scrollDistance = 100;
	}

    function resizeNav(){
        // scroll position variables
        var scrollPosition = $(window).scrollTop(),
            windowHeight = $(window).height(),
            bodyHeight = $('body').outerHeight(),
            footerHeight = $('footer').outerHeight();

        if (scrollPosition >= scrollDistance) {
            //if ((windowHeight + 100) < (bodyHeight + footerHeight)) {
                $('.main-nav').addClass('scrolled');
                $('body').addClass('scrolled');
                closeAllDesktopMainNavs();
                closeAllDesktopUtilityNavs();
                closeDesktopLocationSelect($('[data-js="current-location"]'));
                bannerScrollPadding();
            //}
        } else {
            $('.main-nav').removeClass('scrolled');
            $('body').removeClass('scrolled');
            bannerScrollPadding();
        }

    }

    // resizeNav on page load and on page resize
    $(window).scroll(resizeNav);
    resizeNav();



    $('.hero-slider .slider-inner').slick({
        autoplay:true,
        autoplaySpeed: 10000,
        dots:true,
        slidesToShow:1,
        slidesToScroll:1,
        adaptiveHeight: true,
        arrows: true,
        prevArrow: "<div class='arrow arrow-prev arrow-fallback'><span class='icon-left-arrow-icon' id='prev-slide'></span></div>",
        nextArrow: "<div class='arrow arrow-next arrow-fallback'><span class='icon-right-arrow-icon' id='next-slide'></span></div>"
    });
    (function () {
        var timeout;

        function changeHandler(event, slick, currentSlide) {

            //bypass slick instantly jumping from cloned slide to real slide (causes slides to become askew)
            timeout = setTimeout(function () {
                keyboardFocus(keyboardFocusClass($(slick.$slides[currentSlide]).find('a').first()));
            }, 100);

            //don't do this anymore, only arrow key presses should do it
            $(this).off('afterChange', changeHandler);
        }
        $('.hero-slider').on('keydown', function (event) {

            //left or right arrow
            if (event.which == 39 || event.which == 37) {

                //remove old handlers and timeouts
                $(this).find('.slider-inner').off('afterChange', changeHandler);
                clearTimeout(timeout);

                //attach new handler
                $(this).find('.slider-inner').on('afterChange', changeHandler);
            }
        });
    }());

    $('.hero-slider .slider-inner').on('swipe', function(e,slick, direction){
        $('.hero-slider .slider-inner').slick('slickPause');
    });

    $('.hero-slider .slider-inner .arrow, .slick-dots').on('click', function(){
        $('.hero-slider .slider-inner').slick('slickPause');
    })


    $('.hero-slider .slider-inner').show();


    $('.location-slider .slider-inner').slick({
        autoplay:false,
        autoplaySpeed: 10000,
        dots:true,
        slidesToShow:1,
        slidesToScroll:1,
        arrows: true,
        prevArrow: "<div class='arrow arrow-prev arrow-fallback'><span class='icon-left-arrow-icon' id='prev-slide'></span></div>",
        nextArrow: "<div class='arrow arrow-next arrow-fallback'><span class='icon-right-arrow-icon' id='next-slide'></span></div>"
    });
    (function () {
        var timeout;

        function changeHandler(event, slick, currentSlide) {

            //bypass slick instantly jumping from cloned slide to real slide (causes slides to become askew)
            timeout = setTimeout(function () {
                keyboardFocus(keyboardFocusClass($(slick.$slides[currentSlide]).find('.buttons a').first()));
            }, 100);

            //don't do this anymore, only arrow key presses should do it
            $(this).off('afterChange', changeHandler);
        }
        $('.location-slider').on('keydown', function (event) {

            //left or right arrow
            if (event.which == 39 || event.which == 37) {

                //remove old handlers and timeouts
                $(this).find('.slider-inner').off('afterChange', changeHandler);
                clearTimeout(timeout);

                //attach new handler
                $(this).find('.slider-inner').on('afterChange', changeHandler);
            }
        });
    }());

    if(cookieExists('ocb')) {
        var ocb = cookie('ocb') || {};
        if (ocb && ocb.home) {
            $('.location-slider .slider-inner').slick('slickGoTo', $('.location-slider .slider-inner [data-slide-id="' + ocb.home + '"]').data('slick-index'));
        }
    }

    $('.location-slider .slider-inner').show();

    //lifestyle parallax

if($('.parallax').length > 0){
    $(window).scroll(function() {
        var parallaxTop = $('.parallax').offset().top;

        var parallaxStart = parallaxTop - $('.parallax').height();

        var vpHeight = window.innerHeight * 0.5 - $('.parallax').height();

        var scroll = $(this).scrollTop() - parallaxTop;

        //if ($(this).scrollTop() >= parallaxStart) {

            $('.parallax').find('.background-container').css({transform: "translate3d(0," + scroll * 0.5 + "px, 0)"});
        //}
    });
};


    //fix login form selector in Chrome
    $('[data-js="login-form-select"]').on('change', function (e) {
        $(this).find('option').removeClass('active').attr('aria-selected', 'false').filter($(this).val()).tab('show');
    });


    //fix locator drop down tab issue
    if($('#wpsl-category-list').length > 0){
        $('#wpsl-category-list').attr('tabindex','0');
    }
    //locator error msg
    if($('.locator-wrapper').length > 0){
        $('#wpsl-search-btn').on('click',function(){
            if($('.wpsl-error').length > 0){
                $('.locator-wrapper .error').show();
                $('#wpsl-search-input').attr('aria-describedby', 'wpsl-search-input-error');
            }else{
                $('.locator-wrapper .error').hide();
            }
        })
    }
    //locator tab order
    if ($('.locator-wrapper').length > 0) {

        let observer = new MutationObserver(function () {
            // console.log($('a, :input, [tabindex]').not('#wpsl-gmap *').not('[tabindex="-1"]'));
            // $('a, :input, [tabindex]').not('#wpsl-gmap *').not('[tabindex="-1"]').attr('tabindex', '1');

            $('a.wpsl-directions').each(function () { $(this).attr('aria-label', 'Get directions for ' + $(this).closest('.location').find('.location-name strong').text())});

            $('a, :input, [tabindex]').filter('#wpsl-gmap *').attr('tabindex', '-1');
            $('#wpsl-gmap').attr('aria-hidden', 'true');
        });

        observer.observe($('body').get(0), { subtree: true, childList: true });
    }

    // Magnific Popup
    //check if we've included the plugin first
    if (typeof $.fn.magnificPopup == 'function') {
        // Magnific popup videos
        $(".mfp-video").magnificPopup({
            type: 'iframe',
            closeMarkup: '<button aria-label="close video"><span class="video-close icon-close-icon mfp-close"></span></button>',
            iframe: {
                markup: '<div class="mfp-iframe-scaler">'+
                            '<div class="mfp-close"></div>'+
                            '<iframe class="mfp-iframe" frameborder="0" allowfullscreen allow="autoplay"></iframe>'+
                        '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button
                patterns: {
                    youtube: {
                        index: 'youtube.com/',
                        id: function(url) {
                            var m = url.match(/[\\?\\&]v=([^\\?\\&]+)/);
                            if ( !m || !m[1] ) return null;
                            return m[1];
                        },
                        src: '//www.youtube.com/embed/%id%?autoplay=1'
                    },
                    vimeo: {
                        index: 'vimeo.com/',
                        id: function(url) {
                            var m = url.match(/(https?:\/\/)?(www.)?(player.)?vimeo.com\/([a-z]*\/)*([0-9]{6,11})[?]?.*/);
                            if ( !m || !m[5] ) return null;
                            return m[5];
                        },
                        src: '//player.vimeo.com/video/%id%?autoplay=1'
                    }
                }
            },
            callbacks: {
                //pause any background videos when the popup opens, resume when it closes
                open: function () {
                    var videos = $("video");
                    $('body').addClass('mfp-open');

                    videos.each(function () {
                        var video = $(this),
                            videoElem = video.get(0);

                        //don't pause the mfp video
                        if (video.closest(".mfp-wrap").length === 0) {

                            //if video is playing
                            if (!videoElem.paused && !videoElem.ended) {
                                video.attr("data-was-playing", true);
                                videoElem.pause();
                            }
                        }
                    });
                },
                //resume any background videos when the popup opens, resume when it closes
                close: function () {
                    var videos = $("video[data-was-playing=true]");
                    $('body').removeClass('mfp-open');

                    videos.each(function () {
                        var video = $(this),
                            videoElem = video.get(0);

                        //don't resume the mfp video
                        if (video.closest(".mfp-wrap").length === 0) {

                            videoElem.play();
                        }
                    });
                }
            }
        });

        $(".mfp-inline").magnificPopup({
            type: 'inline',
            closeMarkup: '<span class="video-close icon-menu-close mfp-close"></span>',
            callbacks: {
                open: function () {
                    $('html').addClass('mfp-open');
                    //set the src
                    $('.mfp-wrap [data-src]').each(function () {
                        $(this).attr('src', $(this).data('src'));
                    });
                },
                beforeClose: function () {
                    $('html').removeClass('mfp-open');
                    //unset the src
                    $('.mfp-wrap [data-src]').each(function () {
                        $(this).attr('src', '');
                        $(this).get(0).src = ''; //also unset the src in the JS AudioElement (or unset it again on iframes, not that it matters)
                    });
                }
            }
        });

        $('.mfp-img').magnificPopup({
            type: 'image',
            closeMarkup: '<span class="img-close icon-menu-close mfp-close" tabindex="0"></span>',
            //verticalFit: true, // Fits image in area vertically

            callbacks: {
                open: function () {
                    $('html').addClass('mfp-open');
                },
                //resume any background videos when the popup opens, resume when it closes
                close: function () {
                    $('html').removeClass('mfp-open');
                }
            }
        });
    }
});
